/**
 * Shared SVG gradient definitions for icon hover/selected states.
 * Usage: pass gradient="hover" or gradient="selected" to render the defs,
 * then use `url(#${gradientId})` as the fill value.
 */

export type IconGradient = 'hover' | 'selected';

export function getGradientId(
  prefix: string,
  gradient: IconGradient | undefined
): string | undefined {
  return gradient ? `${prefix}-gradient-${gradient}` : undefined;
}

export function getGradientFill(
  gradientId: string | undefined,
  fallbackColor: string
): string {
  return gradientId ? `url(#${gradientId})` : fallbackColor;
}

export const IconGradientDefs = ({
  gradientId,
  gradient,
}: {
  gradientId: string;
  gradient: IconGradient;
}) => (
  <defs>
    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
      {gradient === 'hover' ? (
        <>
          <stop offset="16.5%" stopColor="rgba(255, 149, 84, 0.8)" />
          <stop offset="100%" stopColor="rgba(255, 73, 53, 0.8)" />
        </>
      ) : (
        <>
          <stop offset="16.5%" stopColor="#FF9554" />
          <stop offset="100%" stopColor="#FF4935" />
        </>
      )}
    </linearGradient>
  </defs>
);
